const Main = () => import('../../pages/main')
export default {
	path: '/renewal',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'renewal',
			path: 'index',
			component: () => import('../../pages/Renewal'),

			meta: {
				requiresAuth: true,
				hidden: false,
				title: '续费管理',
				icon: 'icon-nav icon-nav-renew',
			}
		}
	]
}
